import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    layout: {
        textAlign: 'center',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        px: 3,
        pb: 3,
    },
} satisfies Record<string, SxProps<Theme>>;
